import { BASE_URL } from './environment'
import GET_API_KEY from './getApiKey'

/**
 * Signed out after an hour without activity (the site's SessionTimeoutService). Answers and other requests already
 * count; this also counts tapping, typing and scrolling here, by pinging at most every 5 minutes while someone is
 * using the app, so a session with lots of talking and few answers doesn't end. Started once from index.js.
 */
const PING_EVERY = 5 * 60 * 1000
let started = false

export function startKeepAlive() {
    if (started || typeof window === 'undefined') {
        return
    }
    started = true
    let interacted = false
    let lastPing = Date.now()
    ;['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach((name) =>
        document.addEventListener(name, () => (interacted = true), { passive: true, capture: true })
    )
    setInterval(() => {
        const token = GET_API_KEY()
        if (!interacted || !token || Date.now() - lastPing < PING_EVERY) {
            return
        }
        interacted = false
        lastPing = Date.now()
        fetch(BASE_URL + 'auth/ping', {
            method: 'POST',
            headers: { Accept: 'application/json', Authorization: 'Bearer ' + token },
        }).catch(() => {})
    }, 30000)
}

/**
 * Log out: ends the sign-in on our side too (before, it only cleared this device, so a copy kept working), then
 * clears the device and goes to `next`. keepalive lets the request finish while the page changes.
 */
export function signOut(next) {
    const token = GET_API_KEY()
    if (token) {
        try {
            fetch(BASE_URL + 'auth/logout', {
                method: 'POST',
                keepalive: true,
                headers: { Accept: 'application/json', Authorization: 'Bearer ' + token },
            }).catch(() => {})
        } catch (e) {
            // Leaving anyway.
        }
    }
    localStorage.clear()
    window.location.replace(next)
}
